// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { AuditEntrySummary } from './auditEntrySummary.zod.ts';

export const AuditPage = zod.object({
  "entries": zod.array(AuditEntrySummary),
  "has_more": zod.boolean(),
  "next_cursor": zod.union([zod.string(),zod.null()])
});

export type AuditPage = zod.input<typeof AuditPage>;
export type AuditPageOutput = zod.output<typeof AuditPage>;
